import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getMeetingList, deleteMeeting } from "../../apiService";
import { useEvent } from "../../EventDetailsContext";
import AddMeeting from "./AddMeeting";
import UploadMeetingSummary from "./UploadMeetingSummary";
import MeetingSummary from "./MeetingSummary";
import CustomAlert from "../../CustomAlert";
import EventName from "../../EventName";
const MeetingList = () => {
  const [meetings, setMeetings] = useState([]);
  const [showComponent, setShowComponent] = useState("list");
  const [selectedMeetings, setSelectedMeetings] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [confirmationAction, setConfirmationAction] = useState(null);
  const { eventDetails } = useEvent();
  const eventId = eventDetails ? eventDetails.eventId : null;
  const navigate = useNavigate();

  useEffect(() => {
    const fetchMeetings = async () => {
      try {
        if (!eventDetails) {
          throw new Error("Event details not available");
        }

        console.log("Fetching meetings for EventId:", eventId);
        const data = await getMeetingList(eventId);
        console.log("Meeting List Data:", data);
        if (data && Array.isArray(data)) {
          setMeetings(data);
        } else {
          console.log("Unexpected data format or empty data:", data);
        }
      } catch (error) {
        console.error("Error fetching meeting data:", error);
      }
    };

    fetchMeetings();
  }, [eventDetails]);

  useEffect(() => {
    console.log("Meetings state updated:", meetings);
  }, [meetings]);

  const handleAddMeetingClick = (meeting) => {
    if (meeting) {
      navigate("/events/pre-event-planning/add-meetings", {
        state: { meeting },
      });
    }
  };

  const handleUploadSummaryClick = () => {
    navigate("/events/pre-event-planning/upload-meeting-summary");
  };

  const handleCheckBoxChange = (meetingId) => {
    setSelectedMeetings((prevSelectedMeetings) => {
      if (prevSelectedMeetings.includes(meetingId)) {
        return prevSelectedMeetings.filter((id) => id !== meetingId);
      } else {
        return [...prevSelectedMeetings, meetingId];
      }
    });
  };

  const handleSelectAllChange = () => {
    setSelectAll((prevSelectAll) => {
      const newSelectAll = !prevSelectAll;
      if (newSelectAll) {
        setSelectedMeetings(meetings.map((meeting) => meeting.id));
      } else {
        setSelectedMeetings([]);
      }
      return newSelectAll;
    });
  };

  const handleDeleteMeetings = () => {
    if (selectedMeetings.length === 0) {
      setAlertMessage("Please select a meeting");
      setAlertType("error");
      setShowAlert(true);
      return;
    }
    setAlertMessage("Are you sure you want to delete the selected meetings?");
    setAlertType("warning");
    setShowAlert(true);
    setConfirmationAction(() => confirmDelete);
  };

  const confirmDelete = async () => {
    try {
      await deleteMeeting(selectedMeetings);
      const data = await getMeetingList(eventId);
      setMeetings(data);
      setSelectedMeetings([]);
      setAlertMessage("Selected meetings deleted successfully.");
      setAlertType("success");
      setSelectAll(false);
    } catch (error) {
      console.error("Error deleting meetings:", error);
      setAlertMessage("An error occurred while deleting meetings.");
      setAlertType("error");
    } finally {
      setShowAlert(true);
      setConfirmationAction(null);
    }
  };
  useEffect(() => {
    if (selectedMeetings.length === meetings.length) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [selectedMeetings, meetings]);

  console.log("selectedMeetings", selectedMeetings);

  const handleCloseAlert = () => {
    setShowAlert(false);
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="White_Box">
          <div className="row">
            <div className="col-md-12">
              <EventName />
              {showComponent === "list" && (
                <>
                  <div>
                    <button
                      className="btn AddEventBtn mb-2"
                      onClick={handleUploadSummaryClick}
                    >
                      Upload Meeting Summary
                    </button>
                    <div className="sort-delete-container">
                      <span>
                        <div className="deleteBtn-container">
                          <i
                            className="fa fa-trash"
                            aria-hidden="true"
                            onClick={handleDeleteMeetings}
                          ></i>
                          <span className="delete-tooltip">Delete</span>
                        </div>
                      </span>
                    </div>
                  </div>
                  <div>
                    <Link to="/events/pre-event-planning/add-meetings">
                      <button className="btn AddEventBtn mb-2">
                        Add Meeting
                      </button>
                    </Link>
                  </div>
                  <table className="table Meetingtable">
                    <thead>
                      <tr>
                        <th align="center">
                          <input
                            type="checkbox"
                            checked={selectAll}
                            onChange={handleSelectAllChange}
                          />
                        </th>
                        <th>Name</th>
                        <th>Type</th>
                        <th>Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {meetings.map((meeting) => (
                        <tr key={meeting.id}>
                          <td align="center">
                            <input
                              type="checkbox"
                              checked={selectedMeetings.includes(meeting.id)}
                              onChange={() => handleCheckBoxChange(meeting.id)}
                            />
                          </td>
                          <td>{meeting.name}</td>
                          <td>{meeting.meetingType}</td>
                          <td>{meeting.meetingStartDate}</td>
                          <td>
                            <button
                              className="btn edit-button"
                              onClick={() => handleAddMeetingClick(meeting)}
                            >
                              View
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <MeetingSummary shouldDisplay={true} />
                </>
              )}
              {showComponent === "addMeeting" && <AddMeeting />}
              {showComponent === "uploadSummary" && <UploadMeetingSummary />}
            </div>
          </div>
        </div>
      </div>
      {showAlert && (
        <CustomAlert
          message={alertMessage}
          type={alertType}
          onClose={handleCloseAlert}
          onConfirm={confirmationAction}
        />
      )}
    </div>
  );
};

export default MeetingList;
